import { Box } from '@mui/material';

import { Card, CardContent } from '../../surface/card/card.component';
import { Typography } from '../../data-display/typography/typography.component';

export const ErrorCard = () => {
  return (
    <Card>
      <CardContent>
        <Box p={4}>
          <Typography color='error'>No data. Something went wrong. Please try again.</Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
